/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Gen aksè a bèl editè HTML la"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Verifikatè Aksesibilite"
  },
  "action_to_take_b626a99a": {
    "message": "Aksyon ki dwe fèt:"
  },
  "add_8523c19b": {
    "message": "Ajoute"
  },
  "add_a_caption_2a915239": {
    "message": "Ajoute yon soutit"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Ajoute lòt tèks pou imaj la"
  },
  "add_another_f4e50d57": {
    "message": "Ajoute yon lòt"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Ajoute CC/Soutit"
  },
  "add_image_60b2de07": {
    "message": "Ajoute Imaj"
  },
  "add_one_9e34a6f8": {
    "message": "Ajoute yonn!"
  },
  "additional_considerations_f3801683": {
    "message": "Lòt konsiderasyon"
  },
  "address_applied_64269b0b": {
    "message": "Adrès aplike"
  },
  "address_removed_fcb496e0": {
    "message": "Adrès elimine"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Lyen Adjasan ak menm URL yo dwe yon lyen inik."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Aliyen"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Aliyman ak Lis"
  },
  "all_4321c3a1": {
    "message": "Tout"
  },
  "all_apps_a50dea49": {
    "message": "Tout App yo"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Pèmèt telechajman medya"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Pèmèt telechajman transkripsyon"
  },
  "alpha_15d59033": {
    "message": "Αlpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetik"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Lòt atribi tèks yo pata dwe gen plis pase 120 karaktè."
  },
  "alt_text_611fb322": {
    "message": "Tèks Altèn"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Kopwodui)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Gen yon erè ki fèt pandan lekti fichye a"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Gen yon erè ki fèt pandan demann rezo a"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Gen yon erè ki pase pandan chajman medya ou a."
  },
  "and_7fcc2911": {
    "message": "Ak"
  },
  "angle_c5b4ec50": {
    "message": "Ang"
  },
  "announcement_fb4cb645": {
    "message": "Anons"
  },
  "announcement_list_da155734": {
    "message": "Lis Anons"
  },
  "announcements_a4b8ed4a": {
    "message": "Anons"
  },
  "apply_781a2546": {
    "message": "Aplike"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Aplike tout chanjman Ikòn Kreyatè Ikòn sa a nan Kou a"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Apwoche Limit lan"
  },
  "approximately_e7965800": {
    "message": "Apeprè"
  },
  "apps_54d24a47": {
    "message": "Apps"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Ou kwè vrèman ou vle anile? Chanjman ou fè yo gendwa pa anrejistre."
  },
  "arrows_464a3e54": {
    "message": "Flèch"
  },
  "art_icon_8e1daad": {
    "message": "Ikòn la"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Fòma ap konsève"
  },
  "assignment_976578a8": {
    "message": "Sesyon"
  },
  "assignments_1e02582c": {
    "message": "Sesyon"
  },
  "asterisk_82255584": {
    "message": "Asterisk"
  },
  "attributes_963ba262": {
    "message": "Atribi"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Anrejistreman odyo ak videyo a pa konpatib, tanpri, itilize lòt navigatè."
  },
  "audio_options_feb58e2c": {
    "message": "Opsyon Odyo"
  },
  "audio_options_tray_33a90711": {
    "message": "Plato Opsyon Odyo"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Lektè odyo pou { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Anrejistreman otomatik kontni egziste. Èske w t ap pefere chaje kontni ki te anrejistre otomatikman yo pito?"
  },
  "available_folders_694d0436": {
    "message": "Dosye disponib"
  },
  "background_1bc88842": {
    "message": "Fon"
  },
  "backslash_b2d5442d": {
    "message": "Backslash"
  },
  "bar_ec63ed6": {
    "message": "Ba"
  },
  "basic_554cdc0a": {
    "message": "Bazik"
  },
  "because_501841b": {
    "message": "Paske"
  },
  "below_81d4dceb": {
    "message": "Anba"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Gwo Sèk"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Kowefisyan Binè"
  },
  "black_4cb01371": {
    "message": "Nwa"
  },
  "blue_daf8fea9": {
    "message": "Ble"
  },
  "bold_applied_42d547b7": {
    "message": "Gra aplike"
  },
  "bold_removed_da474a5c": {
    "message": "Gra elimine"
  },
  "border_5b08b06d": {
    "message": "Kontou"
  },
  "bottom_15a2a9be": {
    "message": "Anba"
  },
  "bottom_third_5f5fec1d": {
    "message": "Tyè Enferyè"
  },
  "bowtie_5f9629e4": {
    "message": "Bowtie"
  },
  "brick_f2656265": {
    "message": "Brik"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Anile"
  },
  "cap_product_3a5265a6": {
    "message": "Kaskèt Pwodui"
  },
  "caption_manager_aae0906f": {
    "message": "Jesyonè Soutit"
  },
  "center_align_e68d9997": {
    "message": "Aliyen nan Sant"
  },
  "centered_dot_64d5e378": {
    "message": "Pwen Santre"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Pwen Santre Orizontal"
  },
  "change_alt_text_92654906": {
    "message": "Chanje tèks alt"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Chanje etikèt antèt la an paragraf"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Chanje sèlman nivo antèt sa a"
  },
  "change_text_color_1aecb912": {
    "message": "Chanje koulè tèks"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Chanjman yo ap aplike apre ou sovgade paj sa a."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Chanjman ou fè yo gendwa pa anrejistre."
  },
  "characters_9d897d1c": {
    "message": "Karaktè"
  },
  "characters_no_spaces_485e5367": {
    "message": "Karaktè (san espas)"
  },
  "check_accessibility_3c78211c": {
    "message": "Verifye Aksesibilite"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Pwoblèm verifikasyon Aksesibilite"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Chwazi fichye soutit"
  },
  "choose_usage_rights_33683854": {
    "message": "Itilizasyon dwa itilizasyon..."
  },
  "circle_484abe63": {
    "message": "Sèk"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "Antoure lis ki pa òdone"
  },
  "clear_2084585f": {
    "message": "Efase"
  },
  "clear_image_3213fe62": {
    "message": "Imaj klè"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klike oswa klike epi peze touch majiskil la pou w ka gen aksè a editè html la."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klike pou entegre { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klike pou kache apèsi"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klike pou ensere yon lyen nan editè a"
  },
  "click_to_show_preview_faa27051": {
    "message": "Klike pou afiche apèsi"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Fèmen yon meni oswa yon dyalòg. L ap retounen w tou nan espas editè a"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Fèmen Verifikatè Aksesibilite"
  },
  "close_d634289d": {
    "message": "Fèmen"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Fèmen Modal Rakousi Klavye a"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Fichye soutit la dwe mwens pase { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "CC/Soutit"
  },
  "clubs_suit_c1ffedff": {
    "message": "Klèb (Konbinezon)"
  },
  "collab_575ac7bc": {
    "message": "Kolaborasyon"
  },
  "collaborations_5c56c15f": {
    "message": "Kolaborasyon"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Fèmen pou kache { types }"
  },
  "color_a363e1b0": {
    "message": "Koulè"
  },
  "color_contrast_4c418add": {
    "message": "Kontras Koulè"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Rapò Kontras Koulè"
  },
  "color_picker_6b359edf": {
    "message": "Seleksyonè Koulè"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Seleksyonè Koulè ({ colorName } seleksyone)"
  },
  "color_popup_af39810f": {
    "message": "Fenèt Kontekstyèl Koulè"
  },
  "column_e1ae5c64": {
    "message": "Kolonn"
  },
  "column_group_1c062368": {
    "message": "Gwoup Kolonn"
  },
  "complex_numbers_a543d004": {
    "message": "Nonm Konplèks"
  },
  "computer_1d7dfa6f": {
    "message": "Òdinatè"
  },
  "congruent_5a244acd": {
    "message": "Kongriyan"
  },
  "contains_311f37b7": {
    "message": "Kontni"
  },
  "content_1440204b": {
    "message": "Kontni"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Kontni ki nan editè a ap chanje. Peze Cancel pou w ka konsève kontni orijinal la."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Kontni an ap transfere toujou, si w kontinye li pa p entegre jan li ta dwe a."
  },
  "content_subtype_5ce35e88": {
    "message": "Kontni Subtype"
  },
  "content_type_2cf90d95": {
    "message": "Tip Kontni"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Kontinye nan kontni YouTube"
  },
  "coproduct_e7838082": {
    "message": "Kopwodui"
  },
  "copyright_holder_66ee111": {
    "message": "Titilè Dwa Otè:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Paka ensere kontni: \"{ itemType }\" atik pa konpatib a Canvas pou kounye a."
  },
  "count_40eced3b": {
    "message": "Konte"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 mo}\n    one {1 mo}\n  other {# mo}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# eleman transfere}\n  other {# eleman transfere}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Dokiman Kou"
  },
  "course_files_62deb8f8": {
    "message": "Fichye Kou"
  },
  "course_files_a31f97fc": {
    "message": "Fichye kou"
  },
  "course_images_f8511d04": {
    "message": "Imaj Kou"
  },
  "course_link_b369426": {
    "message": "Lyen Kou"
  },
  "course_links_b56959b9": {
    "message": "Lyen Kou"
  },
  "course_media_ec759ad": {
    "message": "Medya Kou"
  },
  "course_navigation_dd035109": {
    "message": "Navigasyon Kou"
  },
  "create_icon_110d6463": {
    "message": "Kreye ikòn"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Kreye Ikòn Kreyatè Ikòn"
  },
  "creative_commons_license_725584ae": {
    "message": "Lisans Creative Commons"
  },
  "crop_image_41bf940c": {
    "message": "Koupe imaj"
  },
  "crop_image_807ebb08": {
    "message": "Koupe Imaj"
  },
  "cup_product_14174434": {
    "message": "Tèt Pwodui"
  },
  "current_image_f16c249c": {
    "message": "Imaj Aktyèl"
  },
  "current_link_945a47ee": {
    "message": "Lyen Aktyèl"
  },
  "current_volume_level_c55ab825": {
    "message": "Nivo Volim Aktyèl"
  },
  "custom_6979cd81": {
    "message": "Pèsonalize"
  },
  "cyan_c1d5f68a": {
    "message": "Blesyèl"
  },
  "dagger_57e0f4e5": {
    "message": "Ponya"
  },
  "date_added_ed5ad465": {
    "message": "Dat Ajoute"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ikòn Dekoratif"
  },
  "decorative_image_fde98579": {
    "message": "Imaj Dekoratif"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorasyon { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Diminye Endantasyon"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Diminye Zòn Kontni Rich"
  },
  "deep_purple_bb3e2907": {
    "message": "Mov Fonse"
  },
  "default_9db103d": {
    "message": "Defo"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "lis non òdone a pis pa defo"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "lis nimerik pa defo"
  },
  "definite_integral_fe7ffed1": {
    "message": "Entegral Defini"
  },
  "degree_symbol_4a823d5f": {
    "message": "Senbòl Degre"
  },
  "delimiters_4db4840d": {
    "message": "Delimitè"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Dekri Ikòn nan)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Dekri { TYPE })"
  },
  "description_436c48d7": {
    "message": "Deskripsyon"
  },
  "details_98a31b68": {
    "message": "Detay"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Pwen Dagonal"
  },
  "diamond_b8dfe7ae": {
    "message": "Dyaman"
  },
  "diamonds_suit_526abaaf": {
    "message": "Dyaman (Konbinezon)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Tip Dimansyon"
  },
  "directionality_26ae9e08": {
    "message": "Direksyonalite"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Chanje LaTex Dirèkteman"
  },
  "disable_preview_222bdf72": {
    "message": "Dezaktive Apèsi"
  },
  "discussion_6719c51d": {
    "message": "Diskisyon"
  },
  "discussions_a5f96392": {
    "message": "Diskisyon"
  },
  "discussions_index_6c36ced": {
    "message": "Endis Diskisyon"
  },
  "disjoint_union_e74351a8": {
    "message": "Inyon Disosye"
  },
  "display_options_315aba85": {
    "message": "Opsyon Afichaj"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Lyen Afichaj Tèks (Ouvri nan yon nouvo onglè)"
  },
  "div_applied_49ad83fc": {
    "message": "Div aplike"
  },
  "div_removed_d13f8e17": {
    "message": "Div elimine"
  },
  "division_sign_72190870": {
    "message": "Siy Divizyon"
  },
  "document_678cd7bf": {
    "message": "Dokiman"
  },
  "documents_81393201": {
    "message": "Dokiman"
  },
  "done_54e3d4b6": {
    "message": "Fini"
  },
  "double_dagger_faf78681": {
    "message": "Doub Ponya"
  },
  "down_5831a426": {
    "message": "Anba"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Flèch Dyagonal Anba e Agoch"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Flèch Dyagonal Anba e Adwat"
  },
  "download_filename_2baae924": {
    "message": "Telechaje { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Flèch Desann"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Triyabg ki Bay sou Anba"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Deplase yon fichye la a"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Deplase oswa klike pou ka navige sou òdinatè w la."
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Trennen. Itilize flèch anwo ak anba pou chanje dimansyon"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Delè: Plizyè Dat"
  },
  "due_when_7eed10c6": {
    "message": "Delè: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Modifye tèks alt la pou enstans ikpon s a"
  },
  "edit_c5fbea07": {
    "message": "Modifye"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Modifye Lyen Kou"
  },
  "edit_equation_f5279959": {
    "message": "Modifye Ekwasyon"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Modifye Ikòn Kreyatè Ikòn ki Egziste"
  },
  "edit_icon_2c6b0e91": {
    "message": "Chanje Ikòn"
  },
  "edit_link_7f53bebb": {
    "message": "Chanje Lyen"
  },
  "editor_status_bar_653f44ee": {
    "message": "Ba Eta Editè"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Eleman kòmanse a { start }"
  },
  "embed_828fac4a": {
    "message": "Entegre"
  },
  "embed_code_314f1bd5": {
    "message": "Kòd Entegre"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Kontni Entegre Zouti Ekstèn"
  },
  "embed_image_1080badc": {
    "message": "Entegre Imaj"
  },
  "embed_video_a97a64af": {
    "message": "Entegre Videyo a"
  },
  "embedded_content_aaeb4d3d": {
    "message": "Entegre kontni"
  },
  "empty_set_91a92df4": {
    "message": "Ansanm Vid"
  },
  "encircled_dot_8f5e51c": {
    "message": "pwen Ansèkle"
  },
  "encircled_minus_72745096": {
    "message": "Siy Mwen Ansèkle"
  },
  "encircled_plus_36d8d104": {
    "message": "Siy Plis Ansèkle"
  },
  "encircled_times_5700096d": {
    "message": "Siy Miltiplikasyon Ansèkle"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ikòn Jeni"
  },
  "english_icon_25bfe845": {
    "message": "Ikòn Anglè"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Antre tit yon medya"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Antre omwen 3 karaktè pou ka chèche"
  },
  "enter_replacement_text_17631bbc": {
    "message": "Antre tèks ranplasman an"
  },
  "enter_search_text_26cb4459": {
    "message": "Antre tèks rechèch la"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Varyan)"
  },
  "equals_sign_c51bdc58": {
    "message": "Siy Egal"
  },
  "equation_1c5ac93c": {
    "message": "Ekwasyon"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editè Ekwasyon"
  },
  "equilibrium_6ff3040b": {
    "message": "Ekilib"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Klas Ekivalans"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ekivalan (Idantite)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Egziste"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Soti nan Plen Ekran"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Elaji apèsi pa Defo"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Elaji pou w wè { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Lyen Ekstèn"
  },
  "external_tool_frame_70b32473": {
    "message": "Kad zouti ekstèn"
  },
  "external_tools_6e77821": {
    "message": "Zouti Ekstèn"
  },
  "extra_large_b6cdf1ff": {
    "message": "Ekxtra Laj"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Extra Laj ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Piti Anpil"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ikòn Paraskolè"
  },
  "f_function_fe422d65": {
    "message": "F (fonksyon)"
  },
  "fail_544e5dde": {
    "message": "ECHWE"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Echèk rekiperasyon kontni fichye yo"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Echwe pou rekipere kontni nan zouti ekstèn nan"
  },
  "file_name_8fd421ff": {
    "message": "Non fichye"
  },
  "file_preview_21667a6e": {
    "message": "Apèsi fichye"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Apèsi fichye pou { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Quota estokaj fichye a depase"
  },
  "file_url_c12b64be": {
    "message": "URL Fichye"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } ikòn fichye"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } apèsi imaj"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } apèsi tèks"
  },
  "files_c300e900": {
    "message": "Fichye"
  },
  "files_index_af7c662b": {
    "message": "Endis Fichye"
  },
  "find_8d605019": {
    "message": "Jwenn"
  },
  "find_and_replace_6e345933": {
    "message": "Jwenn epi Ranplase"
  },
  "finish_bc343002": {
    "message": "Fini"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Fikse yerachi antèt"
  },
  "flat_music_76d5a5c3": {
    "message": "Plat (Mizik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Ba zouti opsyon eleman fokalizasyon"
  },
  "folder_tree_fbab0726": {
    "message": "Yerachi Dosye"
  },
  "for_all_b919f972": {
    "message": "Pou Tout"
  },
  "format_4247a9c5": {
    "message": "Fòma"
  },
  "format_as_a_list_142210c3": {
    "message": "Fòmate tankou lis"
  },
  "formatting_5b143aa8": {
    "message": "Fòmataj"
  },
  "forward_slash_3f90f35e": {
    "message": "Slash anvan"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Jwenn kontni ki anrejistre otimatikman yo"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Jwenn { count, plural,\n     =0 {# rezilta}\n    one {# rezilta}\n  other {# rezilta}\n}"
  },
  "fraction_41bac7af": {
    "message": "Fraksyon"
  },
  "fullscreen_873bf53f": {
    "message": "Plen Ekran"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Jenerasyon apèsi..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Imaj nan fòma GIF/PNG ki depase { size } KB yo pa konpatib pou kounye a."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Ale sou ba meni editè a"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Ale sou ba zouti editè a"
  },
  "grades_a61eba0a": {
    "message": "Nòt"
  },
  "graphics_text_bc9568bc": {
    "message": "Tèks grafik"
  },
  "greater_than_e98af662": {
    "message": "Siperyè A"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Siperyè ou Egal A"
  },
  "greek_65c5b3f7": {
    "message": "Grèk"
  },
  "green_15af4778": {
    "message": "Vèt"
  },
  "grey_a55dceff": {
    "message": "Gri"
  },
  "group_documents_8bfd6ae6": {
    "message": "Gwoupe Dokiman"
  },
  "group_files_4324f3df": {
    "message": "Gwoup Fichye"
  },
  "group_files_82e5dcdb": {
    "message": "Gwoup fichye"
  },
  "group_images_98e0ac17": {
    "message": "Gwoupe Imaj"
  },
  "group_isomorphism_45b1458c": {
    "message": "Gwoup Izomòfis"
  },
  "group_link_63e626b3": {
    "message": "Lyen Gwoup"
  },
  "group_links_9493129e": {
    "message": "Lyen Gwoup"
  },
  "group_media_2f3d128a": {
    "message": "Gwoupe Medya"
  },
  "group_navigation_99f191a": {
    "message": "Navigasyon Gwoup"
  },
  "h_bar_bb94deae": {
    "message": "Ba H"
  },
  "hat_ea321e35": {
    "message": "Chapo"
  },
  "header_column_f27433cb": {
    "message": "Kolonn antèt"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Ranje ak kolonn antèt"
  },
  "header_row_f33eb169": {
    "message": "Ranje antèt"
  },
  "heading_2_5b84eed2": {
    "message": "Antèt 2"
  },
  "heading_3_2c83de44": {
    "message": "Antèt 3"
  },
  "heading_4_b2e74be7": {
    "message": "Antèt 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Ribrik { h } aplike"
  },
  "heading_h_removed_745f24a6": {
    "message": "Ribrik { h } elimine"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Nivo antèt la pata dwe sote."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Antèt kòmanse pa { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Antèt yo Atribi tèks alt pata dwe genyen plis pase 120 karaktè."
  },
  "health_icon_8d292eb5": {
    "message": "Ikòn Sante"
  },
  "hearts_suit_e50e04ca": {
    "message": "Kè (Konbinezon)"
  },
  "height_69b03e15": {
    "message": "Wotè"
  },
  "hexagon_d8468e0d": {
    "message": "Egzagòn"
  },
  "hide_description_bfb5502e": {
    "message": "Kache deskripsyon"
  },
  "hide_title_description_caf092ef": {
    "message": "Kache { title } deskripsyon"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Mete yon eleman an valè pou ka aktive ba zouti opsyon eleman yo"
  },
  "home_351838cd": {
    "message": "Akèy"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Kijan pou mande ak modifye soutit yo?"
  },
  "html_code_editor_fd967a44": {
    "message": "editè kòd html"
  },
  "html_editor_fb2ab713": {
    "message": "Editè HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Mwen gen otorizasyon pou itilize fichye sa a."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Mwen gen dwa dotè a"
  },
  "icon_215a1dc6": {
    "message": "Ikòn"
  },
  "icon_8168b2f8": {
    "message": "ikòn"
  },
  "icon_color_b86dd6d6": {
    "message": "Ikòn Koulè"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikòn Kreyatè Ikòn"
  },
  "icon_options_7e32746e": {
    "message": "Opsyon Ikòn"
  },
  "icon_options_tray_2b407977": {
    "message": "Plato Opsyon Ikòn"
  },
  "icon_preview_1782a1d9": {
    "message": "Apèsi ikòn"
  },
  "icon_shape_30b61e7": {
    "message": "Fòm Ikòn"
  },
  "icon_size_9353edea": {
    "message": "Gwosè Ikòn"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Si yo kite l vid, tèks lyen an ap afiche tankou non lyen kou a"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Si yo egzije Dwa itilizasyon, fichye a pa p pibliye tout tan li pa aktive sou paj Fichye yo."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Si w pa chwazi dwa itilizasyon yo kounye a, fichye sa a pa p pibliye aprè w fin transfere li."
  },
  "image_8ad06": {
    "message": "Imaj"
  },
  "image_c1c98202": {
    "message": "imaj"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Non fichye imaj yo pata dwe itilize kòm atribi alt ki dekri kontni imaj la."
  },
  "image_options_5412d02c": {
    "message": "Opsyon Imaj"
  },
  "image_options_tray_90a46006": {
    "message": "Plato Opsyon Imaj"
  },
  "image_to_crop_3a34487d": {
    "message": "Imaj pou koupe"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Imaj ak non fichye { file }"
  },
  "images_7ce26570": {
    "message": "Imaj"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Imaj yo dwe gen yon atribi alt ki dekri kontni imaj la."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Pòsyon Imajinè (Nonm Konplèks)"
  },
  "in_element_of_19ca2f33": {
    "message": "Nan (Eleman de)"
  },
  "increase_indent_6af90f7c": {
    "message": "Ogmante Endantasyon"
  },
  "increase_rich_content_area_340b775": {
    "message": "Ogmante Zòn Kontni Rich"
  },
  "indefinite_integral_6623307e": {
    "message": "Entegral Endefini"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } de { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Enferans"
  },
  "infinity_7a10f206": {
    "message": "Enfinite"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Espas tèks pou alpha"
  },
  "input_field_for_blue_561e020a": {
    "message": "Espas tèks pou ble"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Espas tèks pou vèt"
  },
  "input_field_for_red_86a84615": {
    "message": "Espas tèks pou wouj"
  },
  "insert_593145ef": {
    "message": "Ensere"
  },
  "insert_link_6dc23cae": {
    "message": "Ensere Lyen"
  },
  "insert_math_equation_57c6e767": {
    "message": "Ensere Ekwasyon Matematik"
  },
  "integers_336344e1": {
    "message": "Antye"
  },
  "intersection_cd4590e4": {
    "message": "Entèseksyon"
  },
  "invalid_description_991e23bb": {
    "message": "Deskripsyon envalid"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Antre Envalid."
  },
  "invalid_file_c11ba11": {
    "message": "Fichye Envalid"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Tip fichye envalid"
  },
  "invalid_url_cbde79f": {
    "message": "URL envalid"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Pwoblèm { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Italik aplike"
  },
  "italic_removed_17cbab6f": {
    "message": "Italik elimine"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Varyan)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Rakousi Klavye"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Klavye navige nan lyen yo ak touch Tab la. De lyen adjasan ki dirije nan menm destinasyon an ka pèmèt moun k ap itilize klavye yo twompe yo."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ikòn Langaj Da"
  },
  "languages_icon_9d20539": {
    "message": "Ikòn Langaj"
  },
  "large_9c5e80e7": {
    "message": "Laj"
  },
  "large_text_e7ba08cd": {
    "message": "Tèks Laj"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Laj ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Aprann"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Aprann plis sou lyen adjasan yo"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Aprann plis sou kontras koulè yo"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Aprann plis sou òganizasyon antèt paj"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Aprann plis sou estrikti antèt paj yo"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Aprann plis sou antèt tablo yo"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Aprann plis sou tèks alt pou imaj yo"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Aprann plis sou itilizasyon lejand nan tablo yo"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Aprann plis sou itilizasyon non fichye yo tankou tèks alt"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Aprann plis sou itilizasyon lis yo"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Aprann plis sou itilizasyon atribi pòte yo ak tablo yo"
  },
  "leave_as_is_4facfe55": {
    "message": "Kite tankou"
  },
  "left_3ea9d375": {
    "message": "Goch"
  },
  "left_align_43d95491": {
    "message": "Aliyen Agoch"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Sipò Ang Goch"
  },
  "left_arrow_4fde1a64": {
    "message": "Flèch Agoch"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Flèch Agoch avèk Kwochè"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Plafon Goch"
  },
  "left_curly_brace_1726fb4": {
    "message": "Akolad Agoch"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Flèch yon Bò Desann Agoch"
  },
  "left_floor_29ac2274": {
    "message": "Etaj Agoch"
  },
  "left_to_right_e9b4fd06": {
    "message": "De Goch a Dwat"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Flèch yon Bò Monte Agoch"
  },
  "leftward_arrow_1e4765de": {
    "message": "Flèch Agoch"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Triyabg ki Bay Adwat"
  },
  "less_than_a26c0641": {
    "message": "Enferyè A"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Enferyè ou Egal A"
  },
  "library_icon_ae1e54cf": {
    "message": "Ikòn Bibliyotèk"
  },
  "light_blue_5374f600": {
    "message": "Limyè Ble"
  },
  "link_7262adec": {
    "message": "Lyen"
  },
  "link_options_a16b758b": {
    "message": "Opsyon Lyen"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "tip lyen: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Lyen ak tèks ki kòmanse pa { start }"
  },
  "links_14b70841": {
    "message": "Lyen"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Lyen pou ale sou sit ekstèn."
  },
  "lists_cd1336fc": {
    "message": "Lis"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Lis yo dwe fòmate tankou lis."
  },
  "load_more_35d33c7": {
    "message": "Chaje Plis"
  },
  "loading_25990131": {
    "message": "Chajman..."
  },
  "loading_bde52856": {
    "message": "Chajman"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "chajman soutit lan echwe"
  },
  "loading_external_tool_d839042c": {
    "message": "Chajman Zouti Ekstèn"
  },
  "loading_failed_b3524381": {
    "message": "Chajman echwe..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Chajman echwe."
  },
  "loading_folders_d8b5869e": {
    "message": "Chajman dosye"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Chajman espas rezève pou { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Chajman, tanpri tann"
  },
  "loading_preview_9f077aa1": {
    "message": "Chajman apèsi"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Fikse vitès la ak 1x"
  },
  "locked_762f138b": {
    "message": "Bloke"
  },
  "logical_equivalence_76fca396": {
    "message": "Ekivalans Lojik"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Ekivalans Lojik (Kout)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Ekivalans Lojik (Kout e Gwo)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Ekivalans Lojik (Gwo"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Pwen Orizontal Ba"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Kat Pou"
  },
  "math_icon_ad4e9d03": {
    "message": "Ikòn Matematik"
  },
  "media_af190855": {
    "message": "Medya"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Fichye miltimedya an tretman. Tanpri eseye ankò."
  },
  "media_options_saved_560c4ec8": {
    "message": "Opsyon medya yo anrejistre."
  },
  "media_title_2112243b": {
    "message": "Tit Medya"
  },
  "medium_5a8e9ead": {
    "message": "Mwayen"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Mwayen ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Fizyone lyen"
  },
  "mic_a7f3d311": {
    "message": "Mikwo"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikwo Dezaktive"
  },
  "middle_27dc1d5": {
    "message": "Mitan"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimize Apèsi Fichye"
  },
  "minimize_video_20aa554b": {
    "message": "Miminize Videyo"
  },
  "minus_fd961e2e": {
    "message": "Mwens"
  },
  "minus_plus_3461f637": {
    "message": "Mwens/Plis"
  },
  "misc_3b692ea7": {
    "message": "Divès"
  },
  "miscellaneous_e9818229": {
    "message": "Divès"
  },
  "module_90d9fd32": {
    "message": "Modil"
  },
  "modules_c4325335": {
    "message": "Modil"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Deplase imaj pou koupe { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Imaj Miltikolò"
  },
  "multiplication_sign_15f95c22": {
    "message": "Siy Miltiplikasyon"
  },
  "music_icon_4db5c972": {
    "message": "Ikòn Mizik"
  },
  "my_files_2f621040": {
    "message": "Fichye Mwen"
  },
  "n_th_root_9991a6e4": {
    "message": "Enyèm Rasin"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Non"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Natirèl (Mizik)"
  },
  "natural_numbers_3da07060": {
    "message": "Nonm Natirèl"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navige atravè meni oswa ba zouti a"
  },
  "navigation_ee9af92d": {
    "message": "Navigasyon"
  },
  "nested_greater_than_d852e60d": {
    "message": "Siperyè Enbrike"
  },
  "nested_less_than_27d17e58": {
    "message": "Enferyè Enbrike"
  },
  "new_quiz_34aacba6": {
    "message": "Nouvo Quiz"
  },
  "next_40e12421": {
    "message": "Pwochen"
  },
  "next_findtext_9d69f0fe": {
    "message": "Pwochen { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Nou pa t detekte okenn pwoblèm aksesibilite."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Poko gen anons ki kreye."
  },
  "no_announcements_found_20185afc": {
    "message": "Yo pa jwenn anons."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Poko gen sesyon ki kreye."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Yo pa jwenn sesyon."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Pa gen chanjman pou sovgade."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Poko gen diskisyon ki kreye."
  },
  "no_discussions_found_9284063b": {
    "message": "Yo pa jwenn diskisyon."
  },
  "no_e16d9132": {
    "message": "Non"
  },
  "no_file_chosen_9a880793": {
    "message": "Pa gen fichye chwazi"
  },
  "no_headers_9bc7dc7f": {
    "message": "Okenn antèt"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Poko gen modil ki kreye."
  },
  "no_modules_found_2df43a40": {
    "message": "Yo pa jwenn modil."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Poko gen paj ki kreye."
  },
  "no_pages_found_6799350": {
    "message": "Yo pa jwenn paj."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Pa gen apèsi disponib pou fichye sa a."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Poko gen quiz ki kreye."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Yo pa jwenn quiz."
  },
  "no_results_940393cf": {
    "message": "Okenn rezilta."
  },
  "no_results_found_58717065": {
    "message": "Nou pa jwenn rezilta"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Nou pa jwenn rezilta pou { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Pa gen Videyo"
  },
  "none_3b5e34d2": {
    "message": "Okenn"
  },
  "none_selected_b93d56d2": {
    "message": "Anyen Seleksyone"
  },
  "normal_text_7b03da48": {
    "message": "Tèks nòmal"
  },
  "not_equal_6e2980e6": {
    "message": "Pa Egal"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Pa Nan (Pa Yon Eleman De)"
  },
  "not_negation_1418ebb8": {
    "message": "Pa (Negasyon)"
  },
  "not_subset_dc2b5e84": {
    "message": "Pa gen Sou Ansanm"
  },
  "not_subset_strict_23d282bf": {
    "message": "Pa gen Sou Ansanm (Estrik)"
  },
  "not_superset_5556b913": {
    "message": "Pa gen Superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Pa gen Superset (Estrik)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Oktagòn"
  },
  "olive_6a3e4d6b": {
    "message": "Oliv"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Yonn nan stil annapre yo dwe ajoute pou anrejistre yon ikòn: Koulè Ikòn nan, Gwosè Kontou li, Tèks Ikòn nan oswa Imaj"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Gen yonn oswa plizyè fichye ki paka kole. Tanpri eseye monte  fichye yo oswa rale yo lage yo."
  },
  "open_circle_e9bd069": {
    "message": "Sèk Ouvè"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Ouvri dyalòg rakousi klavye sa a"
  },
  "open_title_application_fd624fc5": {
    "message": "Ouvri { title } aplikasyon"
  },
  "operators_a2ef9a93": {
    "message": "Operatè"
  },
  "options_3ab0ea65": {
    "message": "Opsyon"
  },
  "or_9b70ccaa": {
    "message": "Oswa"
  },
  "orange_81386a62": {
    "message": "Zoranj"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Lis Òdone e non Òdone"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Ou ka jwenn lòt rakousi editè nan"
  },
  "outline_color_3ef2cea7": {
    "message": "Koulè Kontou"
  },
  "outline_size_a6059a21": {
    "message": "Gwosè Kontou"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } pa yon pwotokòl valid."
  },
  "page_50c4823d": {
    "message": "Paj"
  },
  "pages_e5414c2c": {
    "message": "Paj"
  },
  "paragraph_5e5ad8eb": {
    "message": "Paragraf"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Paragraf aplike"
  },
  "paragraph_removed_d09320e": {
    "message": "Paragraf elimine"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Paragraf kòmanse ak { start }"
  },
  "parallel_d55d6e38": {
    "message": "Paralèl"
  },
  "partial_derivative_4a9159df": {
    "message": "Pasyèl (Derive)"
  },
  "pass_1c19a2b3": {
    "message": "PASE"
  },
  "paste_5963d1c1": {
    "message": "Kole"
  },
  "pause_12af3bb4": {
    "message": "Poz"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagòn"
  },
  "people_b4ebb13c": {
    "message": "Moun"
  },
  "percentage_34ab7c2c": {
    "message": "Pousantaj"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Pousantaj la dwe se yon chif"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Pousantaj la dwe omwen { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ikòn Pèfòmans Da"
  },
  "perpendicular_7c48ede4": {
    "message": "Pèpandikilè"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Varyan)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ikòn Edikasyon Fizik"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Varyan)"
  },
  "pick_a_color_557abfb0": {
    "message": "Pran yon koulè"
  },
  "pink_68ad45cb": {
    "message": "Woz"
  },
  "pixels_52ece7d1": {
    "message": "Piksèl"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Piksèl yo dwe omwen { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Jwe"
  },
  "play_media_comment_35257210": {
    "message": "Jwe kòmantè medya."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Jwe kòmantè medya pa { name } de { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Aranjman jwè yo"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Tanpri pèmèt Canvas gen aksè a mikwofòn e kamera ou a."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Chwazi yon fichye, tanpri"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Tanpri antre yon non fichye."
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Tanpri, antre yon URL videyo ki valid sou yon platfòm ki konpatib."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Seleksyone yon fichye nan tip sa ki konpatib yo tanpri"
  },
  "plus_d43cd4ec": {
    "message": "Plis"
  },
  "plus_minus_f8be2e83": {
    "message": "Plis/Mwens"
  },
  "posted_when_a578f5ab": {
    "message": "Poste: { when }"
  },
  "power_set_4f26f316": {
    "message": "Ansanm Puisans"
  },
  "precedes_196b9aef": {
    "message": "Presedan"
  },
  "precedes_equal_20701e84": {
    "message": "Presedan Egalite"
  },
  "preformatted_d0670862": {
    "message": "Prefòmate"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Anvan"
  },
  "preview_53003fd2": {
    "message": "Apèsi"
  },
  "preview_a3f8f854": {
    "message": "APÈSI"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Apèsi an sipèpozisyon"
  },
  "preview_inline_9787330": {
    "message": "Apèsi an liy"
  },
  "previous_bd2ac015": {
    "message": "Anvan"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Anvan { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Koulè ou te chwazi anvan yo"
  },
  "prime_917ea60e": {
    "message": "Premye"
  },
  "prime_numbers_13464f61": {
    "message": "Nonm Premye"
  },
  "product_39cf144f": {
    "message": "Pwodwi"
  },
  "proportional_f02800cc": {
    "message": "Pwopòsyonèl"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Pwotokòl la dwe ftp, http, https, mailto, skype, tel oswa sote li"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "pibliye"
  },
  "published_when_302d8e23": {
    "message": "pibliye: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Pumpkin"
  },
  "purple_7678a9fc": {
    "message": "Mov"
  },
  "quaternions_877024e0": {
    "message": "Kwatènè"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Quiz"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Nonm Rasyonèl"
  },
  "real_numbers_7c99df94": {
    "message": "Nonm Reyèl"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Pòsyon Reyèl (yon Nonm Konplèks)"
  },
  "record_7c9448b": {
    "message": "Anrejistre"
  },
  "record_upload_media_5fdce166": {
    "message": "Anrejistre/Chaje Medya"
  },
  "recording_98da6bda": {
    "message": "Anrejistreman"
  },
  "red_8258edf3": {
    "message": "Wouj"
  },
  "relationships_6602af70": {
    "message": "Relasyon"
  },
  "religion_icon_246e0be1": {
    "message": "Ikòn Relijyon"
  },
  "remove_f47dc62a": {
    "message": "Retire"
  },
  "remove_filename_3ea029f6": {
    "message": "Elimine { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Elimine stil antèt"
  },
  "remove_link_d1f2f4d0": {
    "message": "Elimine Lyen"
  },
  "replace_all_d3d68b3": {
    "message": "Ranplase Tout"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Ranplase tout { findText } pa { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Ranplase"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Ranplase { findText } pa { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Ranplase ak"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "te ranplase { alertFindText } pa { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Te ranplase tout { alertFindText } pa { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Reinisyalize"
  },
  "resize_ec83d538": {
    "message": "Redimansyone"
  },
  "restore_auto_save_deccd84b": {
    "message": "Restore anrejistreman otomatik?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Rezilta { index } sou { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Tounikè Envèse (pa sede)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Varyan)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Editè Kontni Rich"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Zòn Teks Rich Peze { OSKey }+F8 pou rakousi Editè Kontni Rich."
  },
  "right_71ffdc4d": {
    "message": "Dwat"
  },
  "right_align_39e7a32a": {
    "message": "Aliyen Adwat"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Sipò Ang Dwat"
  },
  "right_arrow_35e0eddf": {
    "message": "Flèch Adwat"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Flèch Adwat avèk Kwochè"
  },
  "right_ceiling_839dc744": {
    "message": "Plafon Dwat"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Akolad Agoch"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Flèch yon Bò Desann Adwat"
  },
  "right_floor_5392d5cf": {
    "message": "Etaj Adwat"
  },
  "right_to_left_9cfb092a": {
    "message": "De Dwat a Goch"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Flèch yon Bò Monte Adwat"
  },
  "rightward_arrow_32932107": {
    "message": "Flèch Adwat"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Triyang ki Bay Adwat"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Pivote Imaj de -90 degre"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Pivote Imaj de 90 degre"
  },
  "rotation_9699c538": {
    "message": "Wotasyon"
  },
  "row_fc0944a7": {
    "message": "Ranje"
  },
  "row_group_979f5528": {
    "message": "Gwoup ranje"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Malerezman, bèl editè HTML la pa aksesib sou klavye. Gen aksè a bèl editè HTML la la a."
  },
  "save_11a80ec3": {
    "message": "Anrejistre"
  },
  "save_copy_ca63944e": {
    "message": "Sovgade Kopi"
  },
  "save_media_cb9e786e": {
    "message": "Anrejistre Medya"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Sovgade Ikòn Kreyatè Ikòn"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Lektè ekran yo paka wè kisa ki afiche nan yon imaj san tèks altènatif, epi non fichye yo souvan se yon anchenman chif ak lèt ki pa dekri kontèks oswa sans."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Lektè ekran yo paka wè kisa ki afiche nan yon imaj san tèks altènatif, ki dekri kontni ak siyifikasyon imaj la. Tèks altènatif ta dwe senp e klè."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Lektè ekran yo paka wè kisa ki afiche nan yon imaj san tèks altènatif, ki dekri kontni ak siyifikasyon imaj la."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Lektè ekran yo paka entèrete tablo san estrikti ki apwopriye. Antèt tablo yo bay enstriksyon ak kapasite kontni an."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Lektè ekran yo paka entèrete tablo san estrikti ki apwopriye. Lejand tablo yo dekri kontèks ak konpreyansyon jeneral tablo a."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Lektè ekran yo paka entèrete tablo san estrikti ki apwopriye. Antèt tablo yo bay enstriksyon ak rezime kontni an."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Chèche"
  },
  "select_audio_source_21043cd5": {
    "message": "Seleksyone sous odyo"
  },
  "select_crop_shape_d441feeb": {
    "message": "Seleksyone koupe fòm"
  },
  "select_language_7c93a900": {
    "message": "Seleksyone Lang"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Seleksyone sous videyo"
  },
  "selected_274ce24f": {
    "message": "Seleksyone"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Seleksyone { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Seleksyon"
  },
  "set_header_scope_8c548f40": {
    "message": "Defini kapasite antèt"
  },
  "set_minus_b46e9b88": {
    "message": "Ansanm Mwens"
  },
  "set_table_header_cfab13a0": {
    "message": "Defini antèt tablo"
  },
  "sharp_music_ab956814": {
    "message": "Pweti (Mizik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Flèch"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O pou ka ouvri bèl editè html la."
  },
  "shortcut_911d6255": {
    "message": "Rakousi"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Afiche opsyon imaj"
  },
  "show_link_options_545338fd": {
    "message": "Afiche opsyon lyen"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Montre transkripsyon k ap woule"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Montre Transkripsyon k ap Woule"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Itilizatè prevwayan yo navige sou paj wèb yo byen vit, pou yo ka chèche antèt ki gwo oswa an gra. Itilizatè lektè ekran yo konte sou antèt yo pou konpreyansyon kontekstyèl. Antèt yo dwe itilize estrikti ki apwopriye."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Itilizatè prevwayan yo navige sou paj wèb yo byen vit, pou yo ka chèche antèt ki gwo oswa an gra. Itilizatè lektè ekran yo konte sou antèt yo pou konpreyansyon kontekstyèl. Antèt yo dwe klè nan estrikti ki apwopriye."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Varyan)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Imaj Yon sèl Koulè"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Koulè Inik Imaj la"
  },
  "size_b30e1077": {
    "message": "Dimansyon"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Fichye soutit la depase kantite maksimòm { max } kb yo otorize a."
  },
  "small_b070434a": {
    "message": "Piti"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Piti ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Sèk Solid"
  },
  "something_went_wrong_89195131": {
    "message": "Gen yon bagay ki mal fèt."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Gen yon pwoblèm ki pase lè l ap chache aksede ak webcam ou an."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Gen yon bagay ki pase mal ni mwen pa konnen kisa pou m montre w."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Gen yon bagay ki mal fèt. Verifye koneksyon ou, relanse paj la epi eseye ankò."
  },
  "something_went_wrong_d238c551": {
    "message": "Gen yon bagay ki pase mal"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Gen yon bagay ki pase mal pandan n ap pataje ekran w lan."
  },
  "sort_by_e75f9e3e": {
    "message": "Triye Pa"
  },
  "spades_suit_b37020c2": {
    "message": "Pik (Konbinezon)"
  },
  "square_511eb3b3": {
    "message": "Kare"
  },
  "square_cap_9ec88646": {
    "message": "Bouchon Kare"
  },
  "square_cup_b0665113": {
    "message": "Tas Kare"
  },
  "square_root_e8bcbc60": {
    "message": "Rasin Kare"
  },
  "square_root_symbol_d0898a53": {
    "message": "Senbòl Rasin Kare"
  },
  "square_subset_17be67cb": {
    "message": "Sou Ansanm Kare"
  },
  "square_subset_strict_7044e84f": {
    "message": "Sou Ansanm Kare (Estrik)"
  },
  "square_superset_3be8dae1": {
    "message": "Superset Kare"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Superset Kare (Estrik)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "lis kare non òdone"
  },
  "star_8d156e09": {
    "message": "Etwal"
  },
  "start_over_f7552aa9": {
    "message": "Rekòmanse"
  },
  "start_recording_9a65141a": {
    "message": "Kòmanse Anrejistre"
  },
  "steel_blue_14296f08": {
    "message": "Ble Gri"
  },
  "studio_media_options_ee504361": {
    "message": "Opsyon Estidyo Medya a"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Opsyon Plato Medya Studio"
  },
  "styles_2aa721ef": {
    "message": "Stil"
  },
  "submit_a3cc6859": {
    "message": "Soumèt"
  },
  "submitting_b90fac62": {
    "message": "Soumisyon..."
  },
  "subscript_59744f96": {
    "message": "Endis"
  },
  "subset_19c1a92f": {
    "message": "Sou Ansanm"
  },
  "subset_strict_8d8948d6": {
    "message": "Sou ansanm (Estrik)"
  },
  "succeeds_9cc31be9": {
    "message": "Siksè"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Siksè Egal"
  },
  "sum_b0842d31": {
    "message": "Sòm"
  },
  "superscript_8cb349a2": {
    "message": "An Ekspozan"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Superscript ak Subscript"
  },
  "superset_c4db8a7a": {
    "message": "Superset"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (Estrik)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Tip fichye ki aksepte: SRT oswa WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Pase a yon bèl editè HTML"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Pase a yon editè HTML brit"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Chanje a editè html la"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Chanje a editè tèks anrichi a"
  },
  "syllabus_f191f65b": {
    "message": "Pwogram"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Sistèm Odyo Otorize"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Sistèm Odyo Dezaktive"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Flèch"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Antèt tablo kòmanse a { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tablo kòmanse a { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Antèt tablo yo dwe presize kapasite."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tablo yo dwe gen lejand ki dekri kontni tablo a."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tablo yo dwe gen omwen yon antèt."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Ble vèt"
  },
  "text_7f4593da": {
    "message": "Tèks"
  },
  "text_background_color_16e61c3f": {
    "message": "Koulè Fon Tèks"
  },
  "text_color_acf75eb6": {
    "message": "Koulè Tèks"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Li difisil pou li tèks la si pa gen ase kontras ant tèks la ak fon an, espesyalman pou moun ki pa wè byen yo."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Tèks ki pi gwo ke 18pt (oswa an gra 14pt) ta dwe afiche yon to kontras de 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Tèks (opsyonèl)"
  },
  "text_position_8df8c162": {
    "message": "Pozisyon Tèks"
  },
  "text_size_887c2f6": {
    "message": "Gwosè Tèks"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Tèks ki pi piti ke 18pt (oswa an gra 14pt) ta dwe afiche yon to kontras de 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Afichaj dokiman an pwosesis pou kounye a. Tanpri eseye ankò."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Premye antèt nan yon paj ta dwe yon H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Wotè Zòn Kontni Rich la diminye."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Wotè Zòn Kontni Rich la ogmante."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materyèl la nan domèn piblik la"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materyèl la distribye sou lisans Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Materyèl la fè objè de yon ekseksyon - pa egzanp itilizasyon ekitab, dwa pou site oswa lòt dwa daprè lwa sou dwa dotè ki aplikab yo."
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Bèl editè html la pa aksesib sou klavye. Peze Shift-O pou ka ouvri editè html la an mòd brit l."
  },
  "therefore_d860e024": {
    "message": "Kidonk"
  },
  "theta_ce2d2350": {
    "message": "Tèta"
  },
  "theta_variant_fff6da6f": {
    "message": "Tèta (Varyan)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Flèch Epè Desann"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Flèch Epè Agoch"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Flèch Epè Agoch"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Flèch Epè Adwat"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Flèch Epè Adwat"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Flèch Epè Anwo"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dokiman sa a pa kapab afiche nan Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Ekwasyon sa a paka rann nan Afichaj Bazik la."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Imaj sa a pa disponib pou kounye a"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Videyo sa a ka afiche piblisite YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Menm si videyo ou a gen yon bèl tit nan navigatè a, nou pa rive kapab aktyalize li nan baz de done a."
  },
  "thumbnail_e0de666f": {
    "message": "Viyèt"
  },
  "timebar_a4d18443": {
    "message": "Ba a lè"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Tit la pa ka vid"
  },
  "title_ee03d132": {
    "message": "Tit"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Pou Poste: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Tach: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Chanje { summary } gwoup"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Deplase ti boul enffòmasyon an"
  },
  "tools_2fcf772e": {
    "message": "Zouti"
  },
  "top_66e0adb6": {
    "message": "Anlè"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Panèl transkripsyon an disponib nan lajè ki depase 720px."
  },
  "tray_839df38a": {
    "message": "Plato"
  },
  "triangle_6072304e": {
    "message": "Triyang"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Tounikè (Rannman)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "tape Control F9 pouw gen aksè a opsyon imaj yo. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "tape Control F9 pouw gen aksè a opsyon lyen yo. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "tape Control F9 pouw gen aksè a opsyon tablo yo. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Paka detèmine url seleksyon resous"
  },
  "underline_applied_ae01ec97": {
    "message": "Souliyman aplike"
  },
  "underline_removed_3693e17c": {
    "message": "Souliyman elimine"
  },
  "union_e6b57a53": {
    "message": "Inyon"
  },
  "unpublished_dfd8801": {
    "message": "pa pibliye"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "W ap pèdi tout chanjman ki pa sovgade yo."
  },
  "untitled_16aa4f2b": {
    "message": "San tit"
  },
  "untitled_efdc2d7d": {
    "message": "san tit"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Flèch Dyagonal Anwo e Agoch"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Flèch Dyagonal Anwo e Adwat"
  },
  "up_c553575d": {
    "message": "Anwo"
  },
  "updated_link_a827e441": {
    "message": "Lyen aktyalize"
  },
  "upload_document_253f0478": {
    "message": "Chaje Dokiman"
  },
  "upload_file_fd2361b8": {
    "message": "Transfere Fichye"
  },
  "upload_image_6120b609": {
    "message": "Transfere Imaj"
  },
  "upload_media_ce31135a": {
    "message": "Transfè Medya"
  },
  "upload_record_media_e4207d72": {
    "message": "Transfè/Anrejistre Medya"
  },
  "uploading_19e8a4e7": {
    "message": "Chajman"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "lis alfabetik an majiskil"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta an Majiskil"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma an Majiskil"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda an Majiskil"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega an Majiskil"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi an Majiskil"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi an Majiskil"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi an Majiskil"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "lis òdone chif Women an majiskil"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma an Majiskil"
  },
  "uppercase_theta_49afc891": {
    "message": "Tèta an Majiskil"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Epsilon an Majiskil"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi an Majiskil"
  },
  "upsilon_33651634": {
    "message": "Epsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Flèch ki bay sou Anwo e Anba"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Flèch ki bay sou Anwo e Anba (Epè)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Flèch Anwo"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Triyang ki Bay sou Anwo"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Dwa Itilizasyon:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Dwa Itilizasyon (obligatwa)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Itilize tout fllèch yo pou ka navige nan opsyon yo."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Itilize touch flèch yo pou seleksyone yon fòm."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Itilize touch flèch yo pou seleksyone yon dimansyon."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Itilize tout flèch yo pou ka seleksyone yon pozisyon tèks."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Itilize tout flèch yo pou ka seleksyone yon dimansyon tèks"
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Itilize touch flèch yo pou seleksyone dimansyon kontou."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Itilize lektè ekran sa yo pou dekri kontni yon { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Itilize pa lektè ekran yo pou dekri kontni yon imaj"
  },
  "user_documents_c206e61f": {
    "message": "Dokiman Itilizatè"
  },
  "user_files_78e21703": {
    "message": "Fichye Itilizatè"
  },
  "user_images_b6490852": {
    "message": "Imaj Itilizatè"
  },
  "user_media_14fbf656": {
    "message": "Medya Itilizatè"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektè (Notasyon)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Ba Vètikal (Notasyon Konstriktè Ansanm)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Pwen Vètikal"
  },
  "video_options_24ef6e5d": {
    "message": "Opsyon Videyo"
  },
  "video_options_tray_3b9809a5": {
    "message": "Plato Opsyon Videyo"
  },
  "video_player_b371005": {
    "message": "Lektè Videyo"
  },
  "video_player_for_9e7d373b": {
    "message": "Lektè videyo pou "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Lektè videyo pou { title }"
  },
  "video_url_889d3263": {
    "message": "URL Videyo"
  },
  "view_all_e13bf0a6": {
    "message": "Afiche Tout"
  },
  "view_ba339f93": {
    "message": "Afiche"
  },
  "view_description_30446afc": {
    "message": "Afiche deskripsyon"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Afiche rakousi klavye"
  },
  "view_title_description_67940918": {
    "message": "Afiche { title } deskripsyon"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Afiche kantite mo ak karaktè"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Restriksyon Afichaj"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Nou pa detekte yon mikwo ki an fonksyon sou aparèy ou a."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Nou pa detekte yon kamera ki an fonksyon sou aparèy ou a."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Nou pa detekte yon mikwo oswa kamera ki an fonksyon sou aparèy ou a."
  },
  "webcam_disabled_30c66986": {
    "message": "Kamera Dezaktive"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Paj wèb yo dwe gen yon sèl H1 Tit paj la ap itilize otomatikman. Premye antèt nan kontni w lan ta dwe yon H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Lè yo itilize balizaj pou yo ka fòmate eleman yo vizyèlman tankou lis men ki pa di relasyon lis la, itilizatè yo ka rankontre difikilte pou navige nan enfómasyon yo."
  },
  "white_87fa64fd": {
    "message": "Blan"
  },
  "why_523b3d8c": {
    "message": "Poukisa"
  },
  "width_492fec76": {
    "message": "Lajè"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Lajè a wotè a dwe se chif"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Akèy Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Kantite Mo"
  },
  "words_b448b7d5": {
    "message": "Mo"
  },
  "wreath_product_200b38ef": {
    "message": "Pwodui Kouwòn"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Wi"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Ou sou yon palèt koulè. Pou navige al anlè, agoch, anba epi adwat sou palèt la, itilize touch ''W'', ''A'', ''S'' and ''D'' yo respektivman"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Ou sou yon reglèt koulè. Pou navige al agoch oswa adwat glisè a, itilize touch ''A'', ak ''D'' yo respektivman"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Ou sou yon reglèt alpha. Pou navige al agoch oswa adwat glisè a, itilize touch ''A'', ak ''D'' yo respektivman"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Ou gen chanjman ki pa anrejistre nan plato Kreyatè Ikòn nan. Êske w vle kontinye san w pa sovgade chanjman sa yo?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Ou ka bezwen ajiste lòt antèt pou w ka menti yerachi paj la."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Ou pa dwe soumèt yon fichye vid."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Imaj ou a konprese pou Icon Maker a. Imaj ki enferyè a { size } KB yo pa p konprese."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikwo w la bloke nan paramèt navigatè a."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Mikwo w la ak tout kamera w la bloke nan paramèt navigatè a."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Kamera w la bloke nan paramèt navigatè a."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Webcam ou an gendwa ap itilize deja."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL entegrasyon Youtube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Ikòn Rale Imaj"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Ikòn Puse Imaj"
  }
};
formatMessage.addLocale({
  ht: locale
});